(ns teamoesterreich.lebensretter-mode.status-qualification
  (:require [clojure.string]
            [goog.date.DateTime]
            [teamoesterreich.lebensretter-checks :as h-check]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.access-time :refer [access-time]]
            [reagent-material-ui.icons.warning :refer [warning]]
            [teamoesterreich.firebase.storage-provider :as storage-provider]
            [reagent.core :as r]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.ui-helper.preview-modal :as preview-modal]
            [teamoesterreich.lebensretter-mode.widgets :refer [document-view specific-upload-button]]
            [teamoesterreich.util.log :as log]))



(defn fbDate-2-local-date [fb-date]
  (.toLocaleDateString (js/Date. (* 1000 ^js (.-seconds ^js fb-date)))))

(defn status-qualification [text]

  (let [!userId (r/cursor store/app-state [:firebase-uid])
        !actual-user (r/cursor store/app-state [:actual-user])
        !user-documents (r/cursor store/app-state [:user-documents])
        !state (r/atom {:url nil :loading false :show-delete-modal false :enlarge false})
        !enlarge (r/cursor !state [:enlarge])]
    (fn []

      (let [prop-doc (first (reverse (sort-by #(.-seconds ^js (:uploaded %))
                                              (filter (fn [d]
                                                        ;(log/out " ################  filter-eh prop-doc " (:valid d) (:isTraining d))
                                                        (and (not (:deleted d))
                                                             (some #{(:type d)} ["firstAid-certificate"
                                                                                 "other-certificate"
                                                                                 "professionId"
                                                                                 "lebensretter-qualification"
                                                                                 "other"])
                                                             ))
                                                      (mapv second @!user-documents)))))

            valid-doc (first (reverse (sort-by #(.-seconds ^js (:uploaded %))
                                               (filter (fn [d]
                                                         ;(log/out " ################  filter-eh valid-doc " (:valid d) (:isTraining d) (> (* 1000 (.-seconds (:validTo d)) (js/Date.now))))
                                                         (and (> (* 1000 (.-seconds ^js (:validTo d)) (js/Date.now)))
                                                              (not (:rejected d))
                                                              (not (:deleted d))
                                                              (:isTraining_ d)
                                                              ))
                                                       (mapv second @!user-documents)))))
            doc (or valid-doc prop-doc)

            is-quali? (and (get-in @!actual-user [:status-lebensretter-qualification-valid]) (h-check/in-future? (get-in @!actual-user [:status-lebensretter-qualification-until])))

            ]
        (log/out " ################  quali-doc-status  " valid-doc prop-doc " is-quali?" is-quali?)
        (if doc
          (do
            (if (and (:path (if is-quali? valid-doc doc)) (not (:loading @!state)))
              (storage-provider/get-download-url (:path doc)
                                                 (fn [dwn-url]
                                                   ;(log/out "store callback previewUri " (:path doc) dwn-url)
                                                   (swap! !state assoc :url dwn-url :path (:path doc))
                                                   (swap! !state assoc :loading true)
                                                   ))
              (swap! !state assoc :url "")
              )

            (if valid-doc
              [:div {:class "helping-form-check-line" :style {:minHeight "110px"}}
               (log/debug "valid-doc " valid-doc)
               (when (:url @!state) (preview-modal/modal (:url @!state) !enlarge))
               [:div {:class "check-line-icon"}
                [check]]
               [:div {:class "check-line-text"}
                "Qualifikationsnachweis / EH - Zeugnis hochgeladen und geprüft"
                [:br] (:name doc)
                ;(log/out " ################  valid-until " doc)
                [:br]
                (try
                  (when (:validTo doc)
                    [:span "Danke, dein Nachweis ist gültig bis: " [:b (fbDate-2-local-date (:validTo doc))]])
                  (catch js/Error e (log/out "error doc check" e) [:p ""]))
                ;                [(specific-upload-button "lebensretter-qualification" !state !userId "austauschen")]
                ]
               (when (:path doc)
                 (case (:url @!state)
                   "" [:span ""]
                   nil [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
                   (document-view !state (:name doc))
                   ))
               ]
              ;else
              [:div {:class "helping-form-check-line" :style {:minHeight "100px"}}


               (cond
                 (:rejected prop-doc)
                 ;rejected
                 [:<>
                  [preview-modal/modal (:url @!state) !enlarge]
                  [:div {:class "check-line-icon"} [warning {:style {:color "darkred"}}]]
                  [:div {:class "check-line-text"}
                   "Qualifikationsnachweis abgelehnt: "
                   [:br] (:name doc)
                   [:br]
                   [:span {:style {:color "darkred"}} (:rejectMessage prop-doc)]
                   [(specific-upload-button "lebensretter-qualification" !state !userId "hochladen")]]]

                 is-quali?
                 [:<>
                  [:div {:class "check-line-icon"} [check]]
                  [:div {:class "check-line-text"}
                   "Qualifikationsnachweis optional hochladen"
                   [:br] (:name valid-doc)
                   [:br]
                   [:span {:style {:color "#ac740d"}} "Du kannst unten noch zusätzlich einen Qualifikationsnachweis hochladen"]
                   ]]

                 ;waiting
                 :else
                 [:<>
                  [preview-modal/modal (:url @!state) !enlarge]
                  [:div {:class "check-line-icon"} [access-time]]
                  [:div {:class "check-line-text"}
                   "Qualifikationsnachweis hochgeladen bitte warte auf die Validierung."
                   [:br] (:name doc)
                   [:br]
                   [:span {:style {:color "#ac740d"}} "Bitte um Geduld, die Bestätigung des Dokuments ist unsererseits noch ausständig."]
                   [(specific-upload-button "lebensretter-qualification" !state !userId "hochladen")]]])
               (when (:path doc)
                 (case (:url @!state)
                   "" [:span ""]
                   nil [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
                   (document-view !state (:name doc))
                   ))
               ]))
          ;else
          (when (:request-lebensretter @!actual-user)
            [:div {:class "helping-form-check-line"}
             [:div {:class "check-line-icon"}
              [warning {:style {:color "darkred"}}]]
             text
             [(specific-upload-button "lebensretter-qualification" !state !userId)]
             ])
          )))))

(defn status-qualification-extend [text]

  (let [!userId (r/cursor store/app-state [:firebase-uid])
        !actual-user (r/cursor store/app-state [:actual-user])
        !user-documents (r/cursor store/app-state [:user-documents])
        !state (r/atom {:url nil :loading false :show-delete-modal false :enlarge false})
        !enlarge (r/cursor !state [:enlarge])]
    (fn []

      (let [
            valid-doc (first (reverse (sort-by #(.-seconds ^js (:uploaded %))
                                               (filter (fn [d]
                                                         ;(log/out " ################  filter-eh valid-doc " (:valid d) (:isTraining d) (> (* 1000 (.-seconds (:validTo d)) (js/Date.now))))
                                                         (and (> (* 1000 (.-seconds ^js (:validTo d)) (js/Date.now)))
                                                              (not (:rejected d))
                                                              (not (:deleted d))
                                                              (:isTraining d)
                                                              ))
                                                       (mapv second @!user-documents)))))

            prop-doc (first (reverse (sort-by #(.-seconds ^js (:uploaded %))
                                              (filter (fn [d]
                                                        (log/out " ################  filter- check younger  " (:validTo d) " > last doc " valid-doc)
                                                        (and
                                                          (or (nil? (:valid-to valid-doc)) (> (.-seconds ^js (:validTo d)) (.-seconds ^js (:valid-to valid-doc)))) ; younger than last used one)
                                                          (not (:deleted d))
                                                          (not (:isTraining d))
                                                          (some #{(:type d)} ["firstAid-certificate"
                                                                              "other-certificate"
                                                                              "professionId"
                                                                              "lebensretter-qualification"
                                                                              "other"])
                                                          ))
                                                      (mapv second @!user-documents)))))

            doc prop-doc

            ]
        (if doc
          (do
            (when (and (:path doc) (not (:loading @!state)))
              (storage-provider/get-download-url (:path doc)
                                                 (fn [dwn-url]
                                                   ;(log/out "store callback previewUri " (:path doc) dwn-url)
                                                   (swap! !state assoc :url dwn-url :path (:path doc))
                                                   (swap! !state assoc :loading true)
                                                   ))
              )



            [:div {:class "helping-form-check-line" :style {:minHeight "100px"}}
             [preview-modal/modal (:url @!state) !enlarge]
             [:div {:class "check-line-icon"}
              (if (:rejected prop-doc) [warning {:style {:color "darkred"}}] [access-time])]
             (if (:rejected prop-doc)
               ;rejected
               [:div {:class "check-line-text"}
                "Qualifikationsnachweis für Verlängerung abgelehnt: "
                [:br] (:name doc)
                [:br]
                [:span {:style {:color "darkred"}} (:rejectMessage prop-doc)]
                [(specific-upload-button "lebensretter-qualification" !state !userId "hochladen")]]

               [:div {:class "check-line-text"}
                "Qualifikationsnachweis für Verlängerung hochgeladen bitte warte auf die Validierung."
                [:br] (:name doc) (when (:uploaded doc) (str " hochgeladen " (fbDate-2-local-date (:uploaded doc))))
                [:br]
                [:span {:style {:color "#ac740d"}} "Bitte um Geduld, die Bestätigung des Dokuments ist unsererseits noch ausständig."]
                [(specific-upload-button "lebensretter-qualification" !state !userId "hochladen")]])

             (when (:path doc)
               (if (:url @!state)
                 (document-view !state (:name doc))
                 [mui/circular-progress {:style {:float "right" :maxHeight "50px"}}]
                 ))

             ])
          ;else
          (when (:request-lebensretter @!actual-user)
            [:div {:class "helping-form-check-line"}
             [:div {:class "check-line-icon"}
              [warning {:style {:color "darkred"}}]]
             text
             [(specific-upload-button "lebensretter-qualification" !state !userId)]
             ])
          )))))
